import { createIconsConfig } from 'vuestic-ui'

const iconsConfig = createIconsConfig({
  aliases: [
    { name: 'va-arrow-down', to: 'expand_more' },
    { name: 'va-arrow-first', to: 'first_page' },
    { name: 'va-arrow-last', to: 'last_page' },
    { name: 'va-arrow-left', to: 'chevron_left' },
    { name: 'va-arrow-right', to: 'chevron_right' },
    { name: 'va-arrow-up', to: 'expand_less' },
    { name: 'va-calendar', to: 'calendar_today' },
    { name: 'va-check', to: 'check' },
    { name: 'va-clear', to: 'cancel' },
    { name: 'va-close', to: 'close' },
    { name: 'va-loading', to: 'sync' },
    { name: 'va-warning', to: 'warning' },
  ],
  fonts: [
    {
      name: '{icon}',
      resolve: ({ icon }) => ({ class: 'material-symbols-outlined', content: icon }),
    },
  ],
})

export default {
  colors: {
    variables: {
      primary: '#e31919',
      secondary: '#111111',
      success: '#22c55e',
      danger: '#c20a0f',
      warning: '#f59e0b',
      backgroundPrimary: '#000000',
      backgroundSecondary: '#0a0a0a',
      backgroundElement: '#111111',
      textPrimary: '#ffffff',
      textInverted: '#000000',
    },
    threshold: 170,
  },
  icons: iconsConfig,
}
